import React from "react";
import { Countdown } from "../Countdown";
export function UrgencyBar() {
  return <section className="bg-black py-12 px-4 border-y-2 border-[#e10600]" data-id="element-259" data-mp="mn2tb9vfbbvk">
      <div className="max-w-3xl mx-auto text-center" data-id="element-260" data-mp="mp5lo0k1th3g">
        <h2 className="font-condensed text-2xl sm:text-3xl text-[#e10600] tracking-widest mb-6" data-id="element-261" data-mp="rl4fi3o5brb9">
          ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
        </h2>
        <Countdown data-id="element-262" data-mp="wiw9d38cpni3" />
        <p className="text-neutral-400 mt-6" data-id="element-263" data-mp="11kvb68og0ccx">
          ⚠️ Después sube <span className="text-white font-semibold" data-id="element-264" data-mp="11i92u6tq9stn">$7.500 ARS</span>. No vuelve.
        </p>

        <div className="mt-8 max-w-md mx-auto" data-id="element-265" data-mp="15juc7i71zoz3">
          <div className="flex items-center justify-between text-sm mb-2" data-id="element-266" data-mp="1acdpee1twi3d">
            <span className="text-[#e10600] font-semibold" data-id="element-267" data-mp="1fbqktn6rmxhk">🔴 Cupos al precio de lanzamiento</span>
            <span className="text-neutral-400" data-id="element-268" data-mp="1katkes3z8bi5">Quedan pocos</span>
          </div>
          <div className="h-3 bg-neutral-800 rounded-full overflow-hidden" data-id="element-269" data-mp="1k8ql1hgxp60r">
            <div className="h-full bg-[#e10600] rounded-full" style={{
            width: "71%"
          }} data-id="element-270" data-mp="1pafs6m11czjk" />
          </div>
          <p className="text-xs text-neutral-500 mt-2" data-id="element-271" data-mp="1hj34y14om4os">
            71% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </section>;
}